module.exports = __webpack_public_path__ + "img/triangle-outline.9d962bb6.svg";